import React from "react";
import { motion } from "framer-motion";

/**
 * Wraps any block in a scroll-triggered fade-up ("rise") animation,
 * matching the load animation style from the GoLive reference site.
 *
 * - Triggers once, the first time the block scrolls into view
 *   (viewport once: true — it won't re-animate on scroll-back-up)
 * - `delay` lets you stagger multiple blocks/cards in sequence
 * - `y` controls how far it rises from (default 24px)
 *
 * Usage:
 *   <Reveal><h2>Heading</h2></Reveal>
 *   <Reveal delay={0.15}><p>Some text</p></Reveal>
 *   {items.map((item, i) => (
 *     <Reveal key={item.id} delay={i * 0.08}>...</Reveal>
 *   ))}
 */
export const Reveal = ({ children, delay = 0, y = 24, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.6, ease: [0.21, 0.47, 0.32, 0.98], delay }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export default Reveal;
